var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { createSlice } from "@reduxjs/toolkit";
import config from "../../../webpack/config.json";
import { getEnv } from "../../api/env";
import translations from "../../translations/resources/en-GB.json";
var initialState = {
    apis: [],
    mapsOnOverview: [],
    platform: {},
    environment: {},
    selectedTab: "overview",
    listViewSearchInput: "",
    listViewSortInput: "",
    displaySearchBarFor: ["indoorMap"],
    isOverview: false,
    isNoMap: false,
    stepIndex: 0,
    draftsList: [],
    mapInCollectionList: {
        maps: [],
        collectionName: "",
        collectionHrn: null,
        latestSnapshot: "",
    },
    indoorCatalogHrn: "",
    steps: [
        {
            isCompleted: false,
            isSelected: false,
            isDisabled: false,
            stepNumber: 0,
            label: translations.data["venonboard.wizard.step1"],
        },
        {
            isCompleted: false,
            isSelected: false,
            isDisabled: false,
            stepNumber: 1,
            label: translations.data["venonboard.wizard.step2"],
        },
        {
            isCompleted: false,
            isSelected: false,
            isDisabled: false,
            stepNumber: 2,
            label: translations.data["venonboard.wizard.step3"],
        },
    ],
    isLoaded: false,
    isModalUpdateMap: false,
    isModalFreshMap: false,
    isModalDeleteMap: false,
    mapCollectionSelected: false,
    collectionMetaList: [],
    collectionLoaded: false,
    isRealmSetup: false,
    errorCode: 0,
    isAuthorizedForRealmSetup: false,
    isMapAPICalled: false,
    isMigrateMap: false,
    mapOrderObject: {},
    uploadStatus: null,
    placeMapOrderModal: false,
    mapOrdersMetaList: { isLoading: true, mapOrderList: [] },
    completedStep: null,
    isUpdateOrder: false,
    collectionHrns: [],
};
var slice = createSlice({
    name: "app",
    initialState: initialState,
    reducers: {
        getEnvSuccess: function (state, _a) {
            var payload = _a.payload;
            return __assign(__assign({}, state), { environment: payload.environment, platform: payload.platform });
        },
        setSelectedTab: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { selectedTab: payload }));
        },
        setCurrentAppStep: function (state, _a) {
            var currentStep = _a.payload;
            return (__assign(__assign({}, state), { steps: state.steps.map(function (step, i) { return (__assign(__assign({}, step), { isSelected: currentStep === i, isCompleted: currentStep > i })); }) }));
        },
        setPlatformApiList: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { apis: payload }));
        },
        setIsLoaded: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { isLoaded: payload }));
        },
        setDisplaySearchBarFor: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { displaySearchBarFor: payload }));
        },
        setListViewSearchInput: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { listViewSearchInput: payload }));
        },
        setIsModalUpdateMap: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { isModalUpdateMap: payload }));
        },
        setIsModalFreshMap: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { isModalFreshMap: payload }));
        },
        setIsModalDeleteMap: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { isModalDeleteMap: payload }));
        },
        setMapsOnOverview: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { mapsOnOverview: payload }));
        },
        setIsOverview: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { isOverview: payload }));
        },
        setIsNoMap: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { isNoMap: payload }));
        },
        setStepIndex: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { stepIndex: payload }));
        },
        setDraftsList: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { draftsList: payload }));
        },
        setMapInCollectionList: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { mapInCollectionList: payload }));
        },
        setMapCollectionSelected: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { mapCollectionSelected: payload }));
        },
        setCollectionMetaList: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { collectionMetaList: payload }));
        },
        setCollectionLoaded: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { collectionLoaded: payload }));
        },
        setIsRealmSetup: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { isRealmSetup: payload }));
        },
        setIndoorCatalogHrn: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { indoorCatalogHrn: payload }));
        },
        setErroCode: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { errorCode: payload }));
        },
        setIsAuthorizedForRealmSetup: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { isAuthorizedForRealmSetup: payload }));
        },
        setIsMapAPICalled: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { isMapAPICalled: payload }));
        },
        setIsMigrateMap: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { isMigrateMap: payload }));
        },
        setMapOrderObject: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { mapOrderObject: payload }));
        },
        setUploadStatus: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { uploadStatus: payload }));
        },
        setPlaceMapOrderModal: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { placeMapOrderModal: payload }));
        },
        setMapOrdersMetaList: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { mapOrdersMetaList: payload }));
        },
        setCompletedStep: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { completedStep: payload }));
        },
        setIsUpdateOrder: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { isUpdateOrder: payload }));
        },
        setCollectionHRNs: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { collectionHrns: payload }));
        },
    },
});
export var getEnvSuccess = (_a = slice.actions, _a.getEnvSuccess), setPlatformApiList = _a.setPlatformApiList, setCurrentAppStep = _a.setCurrentAppStep, setIsLoaded = _a.setIsLoaded, setSelectedTab = _a.setSelectedTab, setDisplaySearchBarFor = _a.setDisplaySearchBarFor, setListViewSearchInput = _a.setListViewSearchInput, setIsModalUpdateMap = _a.setIsModalUpdateMap, setIsModalFreshMap = _a.setIsModalFreshMap, setIsModalDeleteMap = _a.setIsModalDeleteMap, setMapsOnOverview = _a.setMapsOnOverview, setIsOverview = _a.setIsOverview, setIsNoMap = _a.setIsNoMap, setStepIndex = _a.setStepIndex, setDraftsList = _a.setDraftsList, setMapInCollectionList = _a.setMapInCollectionList, setMapCollectionSelected = _a.setMapCollectionSelected, setCollectionMetaList = _a.setCollectionMetaList, setCollectionLoaded = _a.setCollectionLoaded, setIsRealmSetup = _a.setIsRealmSetup, setIndoorCatalogHrn = _a.setIndoorCatalogHrn, setErroCode = _a.setErroCode, setIsAuthorizedForRealmSetup = _a.setIsAuthorizedForRealmSetup, setIsMapAPICalled = _a.setIsMapAPICalled, setIsMigrateMap = _a.setIsMigrateMap, setMapOrderObject = _a.setMapOrderObject, setUploadStatus = _a.setUploadStatus, setPlaceMapOrderModal = _a.setPlaceMapOrderModal, setMapOrdersMetaList = _a.setMapOrdersMetaList, setCompletedStep = _a.setCompletedStep, setIsUpdateOrder = _a.setIsUpdateOrder, setCollectionHRNs = _a.setCollectionHRNs;
export var isEnvironmentReady = function (state) {
    return Boolean(state.app.platform.config);
};
/**
 * Because CIT/pre-prod environment uses the same domain as production, we force the domain to platform.here.com
 */
export var getPlatformDomain = function (state) {
    if (state.app.environment.environmentId === "pre-prod") {
        return "platform.here.com";
    }
    return state.app.platform.domain;
};
export var fetchEnv = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var response, platform, environment, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                if (!!getState().app.platform.domain) return [3 /*break*/, 2];
                return [4 /*yield*/, getEnv()];
            case 1:
                response = _a.sent();
                platform = response === null || response === void 0 ? void 0 : response[0].data;
                environment = response === null || response === void 0 ? void 0 : response[1].data;
                if (platform && environment) {
                    dispatch(getEnvSuccess({ platform: platform, environment: environment }));
                    window.env = environment;
                    if (config === null || config === void 0 ? void 0 : config[environment === null || environment === void 0 ? void 0 : environment.environmentId]) {
                        window.app = config === null || config === void 0 ? void 0 : config[environment === null || environment === void 0 ? void 0 : environment.environmentId];
                    }
                    else {
                        window.app = config.sit;
                    }
                }
                _a.label = 2;
            case 2: return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var appSteps = function (state) { return state.app.steps; };
export default slice.reducer;
